import { formatGal, formatToEighths, tankKey, endsLabel } from "@/lib/tank";
import { useT } from "@/lib/i18n";

const BADGE = { best: "Best match", possible: "Possible", close: "Close match" };

export const rankOf = (i, deltaPct) => (i === 0 && deltaPct < 5 ? "best" : deltaPct < 12 ? "close" : "possible");

export function Empty({ danger, children }) {
  return (
    <div className={`empty ${danger ? "empty-danger" : ""}`} data-testid={danger ? "find-empty-danger" : "find-empty"}>
      <p>{children}</p>
    </div>
  );
}

export function HitRow({ tank, mfg, sti, lengthLabel, rank, detail, onUse }) {
  const key = tankKey(tank);
  const t = useT();
  return (
    <div className={`hit ${rank === "best" ? "hit-best" : ""} ${rank === "close" ? "hit-close" : ""}`} data-testid={`hit-${key}`}>
      <div className="hit-top">
        <span className="hit-cap">{formatGal(tank.capacity)} gal</span>
        <span className="hit-dia" style={{ color: sti ? "#22D3EE" : undefined }}>{t("{d}\" wide", { d: Math.round(tank.diameter * 10) / 10 })}</span>
        <span className={`badge badge-${rank}`}>{t(BADGE[rank])}</span>
      </div>
      <div className="hit-detail">{detail}</div>
      <div className="hit-mfg">
        {t(mfg)}{lengthLabel ? ` · ${lengthLabel}` : ""}{sti ? ` · ${t("needs a 12 ft stick")}` : ""}
      </div>
      <button type="button" className="use-btn" data-testid={`use-tank-${key}`} onClick={onUse}>{t("Use this tank")}</button>
    </div>
  );
}

export function FillRow({ item, big, onUse }) {
  const key = tankKey(item);
  const t = useT();
  const value = item.fuelInches == null ? t("Too much ullage") : item.over ? t("Full") : formatToEighths(item.fuelInches);
  return (
    <div className="hit" data-testid={`fill-${key}`}>
      <div className="hit-top">
        <span className="hit-dia">{t("{d}\" wide", { d: item.diameter })} · {t(endsLabel(item.ends))}</span>
      </div>
      <div className="hit-mfg">{formatGal(item.capacity)} gal · {item.mfg}</div>
      <div className={`fill-num ${big ? "fill-num-big" : ""}`} data-testid={`fill-inches-${key}`}>{value}</div>
      {item.fuelInches != null && (
        <button type="button" className="use-btn" data-testid={`use-tank-${key}`} onClick={onUse}>{t("Use this tank")}</button>
      )}
    </div>
  );
}
